import {SEARCH_RESULT} from "../types";

export default function searchBook(state = {}, action = {}) {
    switch (action.type) {
        case SEARCH_RESULT:
            return action.data;
        default:
            return state
    }
}